import { SnapshotSchedule } from '@intelligent-play-v2/domain';
import { queryBuilder } from '../../queryBuilder';

export const getSnapshotSchedules = async (
  pitchId: number
): Promise<SnapshotSchedule[]> => {
  const { data } = await queryBuilder('GET', 'snapshot_schedules', { pitchId });
  return data;
};
